module.exports = __webpack_public_path__ + "media/application/images/svgs/plus-circle-977c3136481cf0d713f1c0376f322ba9.svg";